import { render, staticRenderFns } from "./Forgot-Password.vue?vue&type=template&id=d6b2ed6e&scoped=true&"
import script from "./Forgot-Password.vue?vue&type=script&lang=js&"
export * from "./Forgot-Password.vue?vue&type=script&lang=js&"
import style0 from "./Forgot-Password.vue?vue&type=style&index=0&id=d6b2ed6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b2ed6e",
  null
  
)

export default component.exports